import { EMAIL_ATTACHMENT_LIMITS, type BatchAttachmentInfo } from '@fluenceur/types';

export interface EmailAttachmentIssue {
  id: string;
  name: string;
  messageKey: string;
  /** Failed deletions must be retried, not silently dismissed. */
  attachmentId?: string;
}

export interface EmailAttachmentDraft {
  sessionId: string;
  attachments: BatchAttachmentInfo[];
  temporaryIds: string[];
  issues: EmailAttachmentIssue[];
  uploading: boolean;
  deletingId: string | null;
  customized: boolean;
  templateEntryId: string | null;
  templateScope: string | null;
}

export const createEmailAttachmentDraft = (
  attachments: BatchAttachmentInfo[] = []
): EmailAttachmentDraft => ({
  sessionId: crypto.randomUUID(),
  attachments,
  temporaryIds: [],
  issues: [],
  uploading: false,
  deletingId: null,
  customized: false,
  templateEntryId: null,
  templateScope: null,
});

export type UpdateEmailAttachmentDraft = (
  update: (draft: EmailAttachmentDraft) => EmailAttachmentDraft
) => void;

export const attachmentTotalLimit = (provider?: string) =>
  provider === 'outlook'
    ? EMAIL_ATTACHMENT_LIMITS.outlookMaxTotalBytes
    : EMAIL_ATTACHMENT_LIMITS.maxTotalBytes;

export const attachmentSetError = (
  files: Pick<BatchAttachmentInfo, 'size'>[],
  provider?: string
): string | null => {
  if (files.length > EMAIL_ATTACHMENT_LIMITS.maxCount) return 'maxFiles';
  if (files.some((file) => file.size <= 0)) return 'empty';
  if (files.some((file) => file.size > EMAIL_ATTACHMENT_LIMITS.maxFileBytes)) return 'tooLarge';
  if (files.reduce((sum, file) => sum + file.size, 0) > attachmentTotalLimit(provider)) {
    return provider === 'outlook' ? 'outlookTotalTooLarge' : 'totalTooLarge';
  }
  return null;
};
